import openSocket from "socket.io-client";
import { resolveSocketUrl } from "../helpers/resolveSocketUrl";

const pools = new Map();

function poolKey(userId) {
	return String(userId ?? "");
}

function createSocket(userId, companyId) {
	const socket = openSocket(resolveSocketUrl(), {
		query: {
			userId,
			scope: "shared",
			component: "App",
			companyId: companyId ?? "",
		},
		withCredentials: true,
		transports: ["websocket", "polling"],
		path: "/socket.io",
		reconnectionAttempts: 8,
		reconnectionDelayMax: 3000,
		timeout: 20000,
	});

	const nativeDisconnect = socket.disconnect.bind(socket);

	socket.on("connect_error", (err) => {
		const msg = String(err?.message || "");
		if (/session id unknown/i.test(msg)) {
			if (socket.io?.engine) {
				socket.io.engine.close();
			}
			nativeDisconnect();
			socket.connect();
		}
	});

	return { socket, nativeDisconnect };
}

/**
 * Uma conexão Socket.IO por usuário; disconnect() decrementa refs e só fecha no último.
 */
export function acquireSharedSocket({ userId, companyId }) {
	if (userId == null || userId === "") {
		return null;
	}

	const key = poolKey(userId);
	let pool = pools.get(key);
	if (!pool) {
		const resolvedCompanyId =
			companyId != null && companyId !== "" ? String(companyId) : "";
		const { socket, nativeDisconnect } = createSocket(userId, resolvedCompanyId);
		pool = { socket, nativeDisconnect, refs: 0 };
		socket.disconnect = () => releaseSharedSocket({ userId });
		pools.set(key, pool);
	}
	pool.refs += 1;
	return pool.socket;
}

export function releaseSharedSocket({ userId }) {
	const key = poolKey(userId);
	const pool = pools.get(key);
	if (!pool) return;
	pool.refs -= 1;
	if (pool.refs <= 0) {
		pool.nativeDisconnect();
		pools.delete(key);
	}
}

export function disconnectAllSharedSockets() {
	pools.forEach((pool) => {
		pool.nativeDisconnect();
	});
	pools.clear();
}
